import { StandardText, StandardTextProps } from '@brandfolder/react';
import React from 'react';

export const BFStandardText: React.FC<StandardTextProps> = (props) => {
  return <StandardText {...props}>{props.children}</StandardText>;
};
